import { useCallback, useState } from 'react';
import { issueAdminSsoNonce } from './publicApi';
import { ApiError } from './api';

// Хук для SSO-handoff'а в веб-админку с лендинга/кабинета.
// Возвращает open() + state (busy/error), UI решает как их рендерить.
export function useOpenAdmin() {
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const open = useCallback(async () => {
    setBusy(true);
    setError(null);
    try {
      const { nonce } = await issueAdminSsoNonce();
      const adminBase =
        (import.meta.env.VITE_ADMIN_URL as string | undefined)?.replace(/\/$/, '') ||
        'https://admin.resstro.ru';
      window.location.href = `${adminBase}/sso?nonce=${encodeURIComponent(nonce)}`;
    } catch (err) {
      setBusy(false);
      const msg = err instanceof ApiError ? err.message : 'Не удалось открыть админ-панель';
      setError(msg);
      // Дополнительно, алёртом, чтобы заметили в шапке.
      window.alert(msg);
    }
  }, []);

  return { open, busy, error };
}
